import vAlertGLobal from "./v-alert-global.vue";
import vAlertLocal from "./v-alert-local.vue";

export default Vue => {
  Vue.component("v-alert-global", vAlertGLobal);
  Vue.component("v-alert-local", vAlertLocal);
};
